import * as types from './actionTypes';

export const setBoard = (board: any) => ({
  type: types.SET_BOARD,
  board,
});
